import { render, staticRenderFns } from "./ServiceFeeSettings.vue?vue&type=template&id=5554e60a"
import script from "./ServiceFeeSettings.vue?vue&type=script&lang=js"
export * from "./ServiceFeeSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports